import { mapActions, mapGetters, mapMutations } from 'vuex'
import Banner from './components/banner/index.vue'
import Product from '@/components/product/index.vue'
import { Carousel, Slide } from 'vue-carousel'
import { globalLoader } from '@/helpers/variables'
import HomeEsputnik from './components/newsletter/index.vue'
import HomePartners from './components/partners/index.vue'
import HomeFeedbacks from './components/feedbacks/index.vue'
import staticContent from '@/components/static-content/index.vue'
import HomeLeftArrow from '@/components/@icons/HomeLeftArrow.vue'
import HomeRightArrow from '@/components/@icons/HomeRightArrow.vue'
import Vue from 'vue'
import dynamicsHead from "@/mixins/dynamics-head";

export default Vue.extend({
  name: 'home',
  components: {
    Banner,
    Product,
    Carousel,
    Slide,
    staticContent,
    HomeEsputnik,
    HomePartners,
    HomeFeedbacks,
    HomeLeftArrow,
    HomeRightArrow,
  },
  mixins: [dynamicsHead],
  data() {
    return {
      isCountrySelected: localStorage.getItem('country')  !== null,
      videoStatus: false,
      videoVisible: false,
      instagramPosts: null,
      instagramInfo: null,
      newProducts: [],
      bestSellers: [],
      feedbacks: [],
    }
  },
  mounted() {
    this.fetchHeaderMenu()
  },
  created() {
    this.showPopups()
    this.fetchContent()
    this.checkReviewQuery()
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      homePage: 'pages/page',
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList',
      headerMenu: 'setting/headerMenu',
      variables: 'setting/variables',
      globalLoader: 'system/globalLoader',
    }),

    bestSellerItems() {
      if (this.isAuthenticated) {
        if (!this.bestSellers) return []
        if (!this.favourites) return []
        return this.bestSellers.map((e) => {
          const item = this.favourites.find((t) => t.productId === e.id)
          e.selected = !!item
          return e
        })
      } else {
        return this.bestSellers
      }
    },

    newItemsList() {
      if (this.isAuthenticated) {
        if (!this.newProducts) return []
        if (!this.favourites) return []
        return this.newProducts.map((e) => {
          const item = this.favourites.find((t) => t.productId === e.id)
          e.selected = !!item
          return e
        })
      } else {
        return this.newProducts
      }
    },

    activeQueryReview() {
      return this.$route.query.review
    },
  },
  methods: {
    createDataReviewFromQuery() {
      const formatData = {}
      this.$route.query.review.split(';').forEach((item) => {
        console.log()
        const splitData = item.split(':')
        formatData[splitData[0]] = splitData[0] === 'ids' ? splitData[1].split(',') : splitData[1]
      })
      console.log('formatData ===> ', formatData)
      return formatData
    },
    checkReviewQuery() {
      if (!this.isAuthenticated) return
      if (!this.activeQueryReview) return

      console.log('QUERY ====>>> ', this.$route.query.review)
      const dataReview = this.createDataReviewFromQuery()

      this.getProducts(dataReview)
    },
    async getProducts(data) {
      const products = await this.fetchProducts({ ids: data.ids })

      this.changeReviewModal({
        status: true,
        payload: {
          products,
          email: data.email,
          name: data.name,
        },
      })
      console.log(products)
    },
    ...mapMutations({
      changeRestorePopup: 'popups/CHANGE_RESTORE_POPUP',
      changePaymentInfoPopup: 'popups/CHANGE_PAYMENT_INFO_POPUP',
      resetBasket: 'basket/RESET_BASKET',
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      changeSuccessPayment: 'popups/CHANGE_SUCCESS_PAYMENT_POPUP',
      changeReviewModal: 'popups/CHANGE_REVIEW_MODAL',
    }),
    ...mapActions({
      fetchHeaderMenu: 'setting/GET_HEADER_MENU',
      getInstagramPosts: 'home/INSTAGRAM_POSTS',
      login: 'auth/GET_TOKEN',
      fetchHomePage: 'pages/GET_PAGE',
      fetchNewProducts: 'home/GET_NEW_PRODUCTS',
      fetchBestSellers: 'home/GET_BESTSELLER',
      fetchInstagramPosters: 'home/GET_INSTAGRAM_POSTERS',
      fetchProducts: 'products/GET_PRODUCTS',
      getProductFeedbacks: 'home/GET_PRODUCT_FEEDBACKS',
    }),
    showPopups() {
      if (this.$route.query.hasOwnProperty('email') && this.$route.query.hasOwnProperty('token')) {
        this.changeRestorePopup(true)
      }

      if (!this.isAuthenticated) {
        if (this.$route.query.hasOwnProperty('email') && !this.$route.query.hasOwnProperty('token')) {
          this.changeLoginPopup(true)
        }
        if (!this.$route.query.hasOwnProperty('email') && !this.$route.query.hasOwnProperty('token')) {
          this.changeRestorePopup(false)
          // this.changeLoginPopup(true)
        }
      }

      if (this.$route.query.hasOwnProperty('payment-popup')) {
        this.changeSuccessPayment({
          status: true,
          payload: {
            notCall: Number.parseInt(this.$route.query['need-confirm'] || 0) === 1,
          },
        })
      }

      if (this.$route.query.hasOwnProperty('payment')) {
        this.changePaymentInfoPopup(true)
        if (this.$route.query.payment === 'success') {
          this.resetBasket()
        } else {
          this.$router.push({ name: 'buy-flow-order' }).catch(() => {})
        }
      }
    },
    async fetchContent() {
      globalLoader(true)

      await Promise.all([
        this.fetchHomePage('home'),
        this.getProductFeedbacks().then((responseFeedbacks) => (this.feedbacks = responseFeedbacks)),
        this.fetchNewProducts().then((products) => (this.newProducts = products)),
        this.fetchBestSellers().then((products) => (this.bestSellers = products)),
        this.getInstagramPosts().then((instagramPosts) => {
          this.instagramPosts = instagramPosts.data?.posts?.data
          this.instagramInfo = instagramPosts.data
        }),
      ])

      if (this.homePage && this.homePage.video && this.homePage.video.length && this.$refs.video) {
        this.$refs.video.src = this.homePage.video
      }

      this.setPageMetaInfo(this.homePage)

      globalLoader(false)
    },
    videoScroll() {
      if (document.querySelectorAll('video').length > 0) {
        let windowHeight = window.innerHeight,
          videoEl = document.querySelectorAll('video')

        let playButton = document.getElementById('playButton')

        for (var i = 0; i < videoEl.length; i++) {
          var thisVideoEl = videoEl[i],
            videoHeight = thisVideoEl.clientHeight,
            videoClientRect = thisVideoEl.getBoundingClientRect().top

          if (videoClientRect <= windowHeight - videoHeight * 0.5 && videoClientRect >= 0 - videoHeight * 0.5) {
            this.videoStatus = true
            playButton.click()
          } else {
            this.videoStatus = false
            playButton.click()
          }
        }
      }
    },
    playVideo() {
      this.videoStatus = !this.videoStatus
      this.videoStatus ? this.$refs.video.play() : this.$refs.video.pause()
    },
    carouselNav($event, direction) {
      const carousel = this.$refs['carouselBestSellers']
      carousel.advancePage(direction)
    },
    carouselNav2($event, direction) {
      const carousel = this.$refs['carouselNewProducts']
      carousel.advancePage(direction)
    },
    redirectInstagram() {
      window.open(this.instagramInfo.link, '_blank')
    },
  },
})
